import { AssistanceAndLanguagePage } from '@highmark-web/highmark-common';
import { StaticPageWrapper } from './static-page-wrapper.component';

export const BeneficityLanguagePage = () => (
  <StaticPageWrapper>
    <AssistanceAndLanguagePage />
  </StaticPageWrapper>
);
